import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/mobile';

export interface ContactChannelsProps {
  email: {
    emailAddress: string;
  };
  phone: {
    number: string;
    prefix?: string;
  };
}

export class ContactChannels {
  email: {
    emailAddress: string;
  };
  phone: {
    number: string;
    prefix?: string;
  };

  constructor(props: ContactChannelsProps) {
    this.email = props.email;
    this.phone = props.phone;
  }

  get fullPhoneNumber(): string {
    return `${this.phone.prefix}${this.phone.number}`;
  }

  static create(props: ContactChannelsProps): ContactChannels {
    return new ContactChannels(props);
  }

  static isValidEmail(email: string): boolean {
    const emailRegex = /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;
    return emailRegex.test(email);
  }

  static validatePhoneNumber({
    phoneNumber,
    phonePrefix,
  }: {
    phoneNumber: string;
    phonePrefix: string;
  }): boolean {
    const fullPhoneNumber = phonePrefix + phoneNumber;
    if (isValidPhoneNumber(fullPhoneNumber)) return true;
    try {
      const parsedPhoneNumber = parsePhoneNumber(fullPhoneNumber);
      // workaround for Argentinian phone numbers
      // https://github.com/google/libphonenumber/blob/master/FAQ.md#why-is-this-number-from-argentina-ar-or-mexico-mx-not-identified-as-the-right-number-type
      if (parsedPhoneNumber.country === 'AR') {
        return isValidPhoneNumber(`+549${parsedPhoneNumber.nationalNumber}`);
      }
    } catch (error) {
      //no-op, we will return false
    }
    return false;
  }

  static parsePhoneNumber({
    phoneNumber,
    phonePrefix,
  }: {
    phoneNumber: string;
    phonePrefix: string;
  }) {
    const fullPhoneNumber = phonePrefix + phoneNumber;

    return parsePhoneNumber(fullPhoneNumber);
  }
}
